/*
 * @Author: Json Chen
 * @Date: 2021-07-14 15:09:06
 * @LastEditTime: 2021-10-13 16:10:55
 * @LastEditors: Teemo Ding
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/CourierAccount/Components/ModalContents.tsx
 */

import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import { DelModalContent } from '@/src/pages/Settings/Logistics/Components/ModalContents';
import NeedWarehouseLocation from '@/src/pages/Settings/Logistics/Components/NeedWarehouseLocation';
import { Radio } from 'antd';
import { get } from 'lodash';
import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { Image } from 'src/components/Antd';
import {
  ModalContent,
  SectionContainer as Section,
} from 'src/components/Layouts';

import {
  SF, //ZTO
} from '../images';
import { CourierType, SFLocation } from '../type';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import styles from '../style.module.less';

interface IProps {
  setVisiable: (v: boolean) => void;
}

export const AddCourierAccount = ({ setVisiable }: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const radioList = [
    {
      image: SF,
      title: getI18n('storeLogistics.courierAccount.sFCNTitle'),
      value: `${CourierType.SF}-${SFLocation.CN}`,
      description: getI18n('storeLogistics.courierAccount.sFCNDescription'),
    },
    {
      image: SF,
      title: getI18n('storeLogistics.courierAccount.sFHKTitle'),
      value: `${CourierType.SF}-${SFLocation.HK_MO}`,
      description: getI18n('storeLogistics.courierAccount.sFHKDescription'),
    },
    {
      image: SF,
      title: getI18n('storeLogistics.courierAccount.sFGBTitle'),
      value: `${CourierType.SF}-${SFLocation.GLOBAL}`,
      description: getI18n('storeLogistics.courierAccount.sFGBDescription'),
    },
    // {
    //   image: ZTO,
    //   title: 'ZTO Express',
    //   value: CourierType.ZTO,
    //   description: ' Ut pretium pretium tempor. Ut eget imperdiet neque.',
    // },
  ];
  const history = useHistory();
  const params: any = useParams();
  const [radioValue, setRadioValue] = useState<string>('');
  const [courierType, setCourierType] = useState<CourierType | undefined>();
  const [courierLocation, setCourierLocation] = useState<
    SFLocation | undefined
  >();
  const { uuid: warehouseUuid } = params;

  const onModalConfirm = () => {
    if (courierType) {
      history.push(
        `/settings/logistics/courieraccount/setting/${courierType}/${
          courierLocation || 'None'
        }/${warehouseUuid}`,
      );
    }
  };
  const onRadioChange = ({ target }) => {
    const value = get(target.value.split('-'), '[0]', '');
    const location = get(target.value.split('-'), '[1]', '');
    setRadioValue(target.value);
    setCourierType(value);
    setCourierLocation(location);
  };

  return (
    <React.Fragment>
      <ModalContent>
        <Section style={{ paddingTop: 0 }}>
          <Radio.Group
            value={radioValue}
            onChange={onRadioChange}
            className={styles.radioGroup}>
            {radioList.map((item, index) => {
              return (
                <Radio
                  key={index}
                  value={item.value}
                  className={styles.radioItem}>
                  <div className={styles.radioItemContent}>
                    <Image
                      src={item.image}
                      className={styles.radioItemImage}
                      preview={false}></Image>
                    <div className={styles.radioItemText}>
                      <div className={styles.radioItemTextTitle}>
                        {item.title}
                      </div>
                      <div>{item.description}</div>
                    </div>
                  </div>
                </Radio>
              );
            })}
          </Radio.Group>
        </Section>
      </ModalContent>
      <ModalFooter
        onCancel={() => {
          setVisiable(false);
        }}
        okText={getI18n('general.confirm')}
        hideOkButton={!courierType}
        onOk={onModalConfirm}
      />
    </React.Fragment>
  );
};

export { DelModalContent, NeedWarehouseLocation };
